import { TourDefinition } from '../../models/tour/guided-tour.model';

export const EMPLOYEE_PORTAL_TOUR: TourDefinition = {
  id: 'employee-portal',
  version: 1,
  name: 'Employee Portal',
  scope: 'employee-portal',
  homeRoute: '/me/dashboard',
  autoPrompt: true,
  promptTitle: 'Take a quick tour?',
  promptBody:
    'Learn where to find your DTR, payslips, leave requests, and notifications in about a minute.',
  steps: [
    {
      id: 'welcome',
      anchor: 'dashboard-welcome',
      title: 'Welcome to My Dashboard',
      body: 'This is your home base. See your profile summary, attendance, leave balances, and announcements at a glance.',
      placement: 'bottom',
      route: '/me/dashboard',
    },
    {
      id: 'sidebar',
      anchor: 'sidebar-nav',
      title: 'Your Portal Menu',
      body: 'Use the sidebar to reach DTR, payslips, leave requests, overtime, documents, and approvals.',
      placement: 'right',
    },
    {
      id: 'quick-actions',
      anchor: 'dashboard-quick-actions',
      title: 'Quick Actions',
      body: 'File leave, overtime, or jump to payslips and DTR with one click.',
      placement: 'bottom',
      route: '/me/dashboard',
    },
    {
      id: 'attendance',
      anchor: 'dashboard-attendance',
      title: 'Attendance Overview',
      body: 'Track present days, late arrivals, absences, and overtime for the current month.',
      placement: 'left',
      route: '/me/dashboard',
    },
    {
      id: 'leaves',
      anchor: 'dashboard-leaves',
      title: 'Leave Balances',
      body: 'Check remaining leave credits before filing a new request.',
      placement: 'top',
      route: '/me/dashboard',
    },
    {
      id: 'notifications',
      anchor: 'topbar-notifications',
      title: 'Notifications',
      body: 'Approval updates and company alerts appear here. The badge shows unread items.',
      placement: 'bottom',
    },
    {
      id: 'profile',
      anchor: 'topbar-profile',
      title: 'Your Profile',
      body: 'Open your profile to review personal details and account settings.',
      placement: 'bottom',
    },
    {
      id: 'help',
      anchor: 'topbar-wiki',
      title: 'Help & Guides',
      body: 'Open the in-app wiki anytime for step-by-step guides. You can replay this tour from the compass icon.',
      placement: 'bottom',
    },
  ],
};

export function employeePortalTourForRoute(path: string): TourDefinition | null {
  const normalized = path.split('?')[0].split('#')[0];
  if (normalized === '/me' || normalized.startsWith('/me/')) {
    return EMPLOYEE_PORTAL_TOUR;
  }
  return null;
}

export function autoPromptTourForRoute(path: string): TourDefinition | null {
  const tour = employeePortalTourForRoute(path);
  if (!tour?.autoPrompt) {
    return null;
  }

  const normalized = path.split('?')[0].split('#')[0];
  if (tour.homeRoute && normalized !== tour.homeRoute) {
    return null;
  }

  return tour;
}
